import { marketoForm } from "@areas/LeadGeneration/Views/Blocks/MarketoFormBlock/js/xyl.views.marketoForm";
import freeTextBlock from "@areas/Core/Views/Blocks/FreeTextBlock/xyl.views.freeTextBlock";
import flippableCard from "@areas/Core/Views/Blocks/FlippableCardBlock/xyl.views.flippable-card";
import immersiveTemplateCarousel from "@blocks/ImmersiveTemplateCarouselBlock/xyl.views.immersiveTemplateCarouselBlock";
import immersiveTemplateCarouselFlipCardBlock from "@blocks/ImmersiveTemplateCarouselFlipCardBlock/xyl.views.immersiveTemplateCarouselFlipCardBlock";
import quoteCarouselBlock from "@areas/Core/Views/Blocks/QuoteCarouselBlock/quoteCarouselBlock.js";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const blocks: XylView[] = [
	marketoForm,
	freeTextBlock,
	immersiveTemplateCarousel,
	immersiveTemplateCarouselFlipCardBlock,
	quoteCarouselBlock,
	flippableCard,
];
